/* eslint-disable no-use-before-define */
import { toast } from 'react-toastify';
import UomService from '../../services/UomService';
import UomTypes from '../types/UomTypes';

//* get all department list items
function getAll(pageOption, sortData, keyword) {
  return async (dispatch) => {
    dispatch({ type: UomTypes.GET_UOM_LIST_REQUEST });
    try {
      const res = await UomService.getAll(pageOption, sortData, keyword);
      dispatch({
        type: UomTypes.GET_UOM_LIST_SUCCESS,
        payload: res.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: UomTypes.GET_UOM_LIST_ERROR,
          error: error.response
        });
      }
    }
  };
}

const updateQueryParams = (paging, sorting, keyword) => ({
  type: UomTypes.UPDATE_UOM_QUERY_PARAMS,
  payload: { paging, sorting, keyword }
});

function add(postData, setErrors, submitting, closeModal) {
  return async (dispatch, getState) => {
    dispatch({ type: UomTypes.ADD_UOM_REQUEST });
    try {
      const res = await UomService.add(postData);
      dispatch({ type: UomTypes.ADD_UOM_SUCCESS, payload: res.data });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().uom.queryParams;
      setTimeout(() => dispatch(UomAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      closeModal();
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: UomTypes.ADD_UOM_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function getItem(code) {
  return async (dispatch) => {
    dispatch({ type: UomTypes.GET_UOM_ITEM_REQUEST });
    try {
      const res = await UomService.getItem(code);
      dispatch({
        type: UomTypes.GET_UOM_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: UomTypes.GET_UOM_ITEM_ERROR,
          error: error.response
        });
      }
    }
  };
}

function update(code, postData, setErrors, submitting, navigate) {
  return async (dispatch, getState) => {
    dispatch({ type: UomTypes.UPDATE_UOM_REQUEST });
    try {
      const res = await UomService.update(code, postData);
      dispatch({
        type: UomTypes.UPDATE_UOM_SUCCESS,
        payload: res.data
      });
      if (res.status === 202 && res.data && res.data.message) {
        toast.info(res.data.message);
      } else if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      const { paginationData, sortingData, keyword } = getState().uom.queryParams;
      setTimeout(() => dispatch(UomAction.getAll(paginationData, sortingData, keyword)), 500);
      submitting(false);
      navigate('/');
    } catch (error) {
      submitting(false);
      if (error && error.response) {
        dispatch({
          type: UomTypes.UPDATE_UOM_ERROR,
          error: error.response
        });
        if (error.response.status === 422) {
          if (error.response.data && error.response.data.errors) {
            toast.error(error.response.data.message);
            setErrors(error.response.data.errors);
          }
        }
      }
    }
  };
}

function deleteItem(code, closeModal) {
  return async (dispatch) => {
    dispatch({ type: UomTypes.DELETE_UOM_REQUEST });
    try {
      const res = await UomService.deleteItem(code);
      dispatch({
        type: UomTypes.DELETE_UOM_SUCCESS,
        payload: res.data.data
      });
      if (res.data && res.data.message) {
        toast.success(res.data.message);
      }
      setTimeout(() => dispatch(UomAction.getAll()), 500);
      closeModal();
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: UomTypes.DELETE_UOM_ERROR,
          error: error.response
        });
        closeModal();
      }
    }
  };
}

function getActiveAll() {
  return async (dispatch) => {
    dispatch({ type: UomTypes.GET_ACTIVE_UOM_REQUEST });
    try {
      const res = await UomService.getActiveAll();
      dispatch({
        type: UomTypes.GET_ACTIVE_UOM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: UomTypes.GET_ACTIVE_UOM_ERROR,
          error: error.response
        });
      }
    }
  };
}

const UomAction = {
  getAll,
  add,
  update,
  getItem,
  deleteItem,
  getActiveAll,
  updateQueryParams
};

export default UomAction;
